var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTurnUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.969 168.969C327.594 178.344 312.406 178.344 303.031 168.969L216 81.938V488C216 501.25 205.25 512 192 512H24C10.75 512 0 501.25 0 488S10.75 464 24 464H168V81.938L80.969 168.969C71.594 178.344 56.406 178.344 47.031 168.969S37.656 144.406 47.031 135.031L175.031 7.031C179.719 2.344 185.844 0 192 0S204.281 2.344 208.969 7.031L336.969 135.031C346.344 144.406 346.344 159.594 336.969 168.969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTurnUp);
export default __webpack_public_path__ + "static/media/arrow-turn-up.4e4e5f0c8d0c1ee0e106685c5c0ce055.svg";
export { ForwardRef as ReactComponent };